export const isDemoMode = process.env.REACT_APP_DEMO_MODE === "true";

const configuredApiBaseUrl = process.env.REACT_APP_API_BASE_URL || "http://localhost:8080/api";

export const apiBaseUrl = configuredApiBaseUrl.replace(/\/+$/, "");
